import { IconButton, styled } from "@mui/material";
import { clientConfigFn } from "clientConfig";
export const NavbarIconButton = styled(IconButton)(() => ({
    "& .MuiSvgIcon-root path": {
        fill: clientConfigFn().navbarTextColor,
    },
}));
